export class GetRoleComponentsRequest {
  roleComponentId: number;
  userId: number;
}
